import React, { useState } from 'react';
import PropTypes from 'prop-types';

import GenericTextInputField from '../../../commons/form-fields/GenericTextInputField';
import { LightBlueAlert } from '../../../commons/Alerts';
import AddressFieldsSection from './AddressFieldsSection';

const ConsultantInvoiceWireTransferSection = ({ consultantCountry }) => {
    const [accountNumberVisible, setAccountNumberVisibility] = useState(true);

    return (
        <div>
            <LightBlueAlert>
                This site uses <b>HTTPS</b> to securely exchange data via{' '}
                <b>Encryption</b>. Your bank details are safe with us.
            </LightBlueAlert>

            <div className="mt-4">
                <GenericTextInputField
                    name="consultantInvoiceWireTransferDetails.bankName"
                    label="Bank Name"
                    type="text"
                    required={true}
                />
                <GenericTextInputField
                    name="consultantInvoiceWireTransferDetails.accountHolderName"
                    label="Account Holder Name"
                    type="text"
                    required={true}
                />

                <div className="md:flex">
                    <div className="md:w-1/2 md:pr-1">
                        {/* id contains "otp" to signal Chrome's password manager that this is not a login password field,
                           suppressing the "Save password?" and breached-password prompts. */}
                        <GenericTextInputField
                            name="consultantInvoiceWireTransferDetails.accountNumber"
                            label="Account Number"
                            id="wire-transfer-otp"
                            type={accountNumberVisible ? 'text' : 'password'}
                            validateAndRequiredAlphaNumericText={true}
                            onFocus={() => setAccountNumberVisibility(true)}
                            onBlur={() => setAccountNumberVisibility(false)}
                        />
                    </div>

                    <div className="md:w-1/2 md:pl-1">
                        <GenericTextInputField
                            name="consultantInvoiceWireTransferDetails.accountNumberConfirm"
                            label="Confirm Account Number"
                            type="text"
                            validateAndRequiredAlphaNumericText={true}
                            onPaste={(e) => e.preventDefault()} // this prevents the pasting operation
                        />
                    </div>
                </div>

                <GenericTextInputField
                    name="consultantInvoiceWireTransferDetails.swiftCode"
                    label="SWIFT Code"
                    type="text"
                    required={true}
                />

                <AddressFieldsSection
                    fieldName="consultantInvoiceWireTransferDetails.beneficiaryAddress"
                    consultantCountry={consultantCountry}
                />
            </div>
        </div>
    );
};

ConsultantInvoiceWireTransferSection.propTypes = {
    consultantCountry: PropTypes.string.isRequired,
};

export default ConsultantInvoiceWireTransferSection;
